<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** Constants */
import ValidationCardStatus from '../../constants/ValidationCardStatus'
import { ORE_EMAIL } from '../../constants/ContactData'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ReportingGroupApi from '../../api/ReportingGroupApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import ValidationPeriodApi from '../../api/ValidationPeriodApi'
import VfeApi from '../../api/VfeApi'
import FormAccessApi from '../../api/FormAccessApi'
import ActivityLogsApi from '../../api/ActivityLogsApi'
/** UI Components */
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Tag } from 'buefy/dist/components/tag'
import { Checkbox } from 'buefy/dist/components/checkbox' 
import { Message } from 'buefy/dist/components/message'
import { Loading } from 'buefy/dist/components/loading'
import { Modal } from 'buefy/dist/components/modal'
import Timer from '../../components/TimeRemaining'

const AUTHORIZED_ROLE = 'Authorized Representative';
const VCARD_SECTION_LOG = 'Validation Card';
const VFE_SECTION_LOG = 'Validation Card - Form Entry';

const VPERIOD_READY_STATUS = 'Ready';
const VPERIOD_OPEN_STATUS = 'Open';

export default {
    name : "DashboardView",
    components: {
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-checkbox' : Checkbox,
        'b-message' : Message,
        'b-loading' : Loading,
        'b-tag' : Tag,
        'b-modal' : Modal,
        Timer
    },
	computed : {
		...mapState({
            activeNav : "activeNav",
            allForms : "allFormsData",
            profile : "userProfile",
            token : "xOreAuth",
            allValidationEntries : "allActiveValidationEntries"
        }),
        profileHandles () {
            var repGroupIds = []
            var repEntityIds = []
            var repUnitIds = []
            if (this.profile) {
                if (this.profile.reportingGroups && this.profile.reportingGroups.length > 0) {
                    repGroupIds = this.profile.reportingGroups.map(g => {
                        return g.repGroupIdFk
                    })
                }
                if (this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                    repEntityIds = this.profile.reportingEntities.map(e => {
                        return e.repEntityIdFk
                    })
                }
                if (this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    repUnitIds = this.profile.reportingUnits.map(u => {
                        return u.repUnitIdFk
                    })
                }
            }
            return {
                repGroupIds,
                repEntityIds,
                repUnitIds
            }
        },
        profileHandlesData () {
            var repGroups = []
            var repEntities = []
            var repUnits = []
            if (this.profile) {
                if (this.profile.reportingGroups && this.profile.reportingGroups.length > 0) {
                    repGroups = this.profile.reportingGroups
                }
                if (this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                    repEntities = this.profile.reportingEntities.map(en => {
                        return {
                            repGroupIdFk: en.repGroupIdFk,
                            repEntityIdFk: en.repEntityIdFk,
                            repUnitIdFk: en.repUnitIdFk,
                        }
                    })
                }
                if (this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    repUnits = this.profile.reportingUnits.map(un => {
                        return {
                            repGroupIdFk: un.repGroupIdFk,
                            repEntityIdFk: un.repEntityIdFk,
                            repUnitIdFk: un.repUnitIdFk,
                        }
                    })
                }
            }
            return {
                repGroups,
                repEntities,
                repUnits
            }
        },
        hasReportingSelection(){
            if (this.forGenEntityLevel.length==0 && this.forGenUnitLevel.length==0) {
                return false;
            }
            return true;
        },
        isAllSelected(){
            let numReporting= this.ungeneratedEntity.length + this.ungeneratedUnit.length
            let activeSelection = this.forGenEntityLevel.length + this.forGenUnitLevel.length;
            if (numReporting != activeSelection) {
                return false;
            }
            return true;
        },
        btnSelectionLabel(){
            if (!this.isAllSelected) {
                return 'Check';
            }
            return 'Uncheck';
        },
        hasSwimLaneItems(){
            let numItems = 0;
            if (this.swimLanes) {
                if (this.swimLanes.length > 0) {
                    this.swimLanes.forEach(lane=>{
                        numItems = numItems + lane.items.length;
                    });
                }
            }
            if (numItems > 0) {
                return true;
            }
            return false;
        },
        readableDeadline(){
            if (this.validationPeriod) {
                if (this.validationPeriod.dueDate!=null) {
                    return this.$moment(this.validationPeriod.dueDate,'YYYY-MM-DD HH:mm:ss').format('lll');//format('MMM. DD, YYYY HH:mm:ss');
                }
            }
            return "";
        },
        dueDateEpoch(){
            if (this.validationPeriod) {
                if (this.validationPeriod.dueDate!=null) {
                    return parseInt(this.$moment(this.validationPeriod.dueDate,'YYYY-MM-DD HH:mm:ss').format('x'),10)
                }
            }
            return null;
        },
        hasActiveCards(){
            if (this.activeValidationCards.entityLevelValidationCards.length == 0 &&
                this.activeValidationCards.unitLevelValidationCards.length == 0) {
                return false;
            }
            return true;
        },
        ungeneratedEntity () {
            var remainingEntity = []
            if (this.profile) {
                if (this.hasActiveCards) {
                    if (this.profile && this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                        remainingEntity = this.profile.reportingEntities.filter(ent=> {
                            return ArrayUtil.getIndex(this.activeValidationCards.entityLevelValidationCards,'repEntityIdFk',ent.repEntityIdFk) === null
                        })
                    }
                }
            }
            return remainingEntity
        },
        ungeneratedUnit () {
            var remainingUnit = []
            if (this.hasActiveCards) {
                if (this.profile && this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    remainingUnit = this.profile.reportingUnits.filter(unit=> {
                        return ArrayUtil.getIndex(this.activeValidationCards.unitLevelValidationCards,'repUnitIdFk',unit.repUnitIdFk) === null
                    })
                }
            }
            return remainingUnit
        },
        hasUngeneratedVcard () {
            if (this.ungeneratedEntity.length === 0 && this.ungeneratedUnit.length === 0) {
                return false
            }
            return true
        }
    },
    data(){
        return {
            activeValidationCards : {
                entityLevelValidationCards : [],
                unitLevelValidationCards : []
            },
            currentYear : new Date().getFullYear(),
            reportingYearLov : [],
            selectedReportingYear : null,
            userFormAccess : {},
            showEntityConfirmation: false,
            forGenEntityLevel : [],
            forGenUnitLevel : [],
            swimLanes: [],
            dndOptions: {
                dropzoneSelector: ".drag-inner-list",
                draggableSelector: ".drag-item",
                onDrop: this.onDrop,
                onDragstart : this.onDragStart,
                onDragend : this.onDragEnd
            },
            showAttestation : false,
            validationPeriod : null,
            isLoading : false,
            supportEmail : ORE_EMAIL,
            showGenerateRemaining: false,
            errorData : null,
            globalLoading: null,
            allMarked: false
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData",
            setActiveNav : "updateActiveNav",
            setProfile : "updateUserProfile",
            updateValidationEntries: "updateValidationEntries"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            this.isLoading = true;
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.isLoading = false;
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                this.getReportingYearLov();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.isLoading = false;
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getReportingYearLov(){
            this.isLoading = true;
            this.reportingYearLov = [];
            this.selectedReportingYear = null;
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
            // Default reporting year is current year minus 1; or previous year
            let defaultRepYear = parseInt(this.$moment().format('YYYY'),10) - 1;

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {

                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (repYearInDb > 0) {
                            try {
                                /* Pre-select the year with data (from DB) */ 
                                this.selectedReportingYear = repYearInDb[0];
                            }
                            catch(yrErr){}
                        }
                        else {
                            this.selectedReportingYear = defaultRepYear;
                        }

                        if (this.selectedReportingYear != null) {
                            this.getValidationPeriod();
                            // this.getActiveValidationCards();
                        }
                        else {
                            /** If there's no selected year, stop loading indicator */
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getValidationPeriod(){
            this.validationPeriod = null;

            ValidationPeriodApi.get({
                reportingYear : this.selectedReportingYear,
                status : ''
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length == 0) {
                            // No validation period
                            this.isLoading = false;
                        }
                        else {
                            if (response.data[0]) {
                                this.validationPeriod  = response.data[0];
                            }  
                            this.getActiveValidationCards();
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationPeriod.get');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationPeriod.get');
            });
        },
        getActiveValidationCards(){
            // Reset models
            this.activeValidationCards.entityLevelValidationCards = [];
            this.activeValidationCards.unitLevelValidationCards = [];
            this.swimLanes = [];

            ValidationCardApi.getPerUser({
                userId : this.profile.userId,
                repGroupIdFk : this.profile.repGroupIdFk,
                repEntityIdFk : this.profile.repEntityIdFk,
                repUnitData: this.profileHandlesData.repUnits,
                reportingYear : this.selectedReportingYear,
                repGroupData: this.profileHandlesData.repGroups,
                repEntityData: this.profileHandlesData.repEntities
            })
            .then(response=>{
                let cards = response.data;
                /** Filter cards that belong to user only */
                /*let retCards = response.data;
                let cards = {
                    entityLevelValidationCards : retCards.entityLevelValidationCards
                };
                if (repUnitIds.length == 0) {
                    if (retCards.unitLevelValidationCards.length > 0) {
                        cards.unitLevelValidationCards = [];
                    }
                }
                else {
                    if (retCards.unitLevelValidationCards.length > 0) {
                        let userUnitCards = retCards.unitLevelValidationCards.filter(u=>{
                            return (ArrayUtil.getIndex(repUnitIds,u.repUnitIdFk)!=null)
                        });
                        cards.unitLevelValidationCards = userUnitCards;
                    }
                } */
                if (response.data) {
                    if (!response.data.error) {
                        if (cards.entityLevelValidationCards.length > 0 ||
                            cards.unitLevelValidationCards.length > 0) {
                            this.prepSwimLanes(cards);
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getPerUser');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getPerUser');
            });
        },
        getStarted(){
            if (!this.selectedReportingYear) {
                this.$dialog.alert({
                    title: 'Error',
                    message: 'Please select a reporting year.',
                    type: 'is-danger'
                });
                return false;
            }
            this.showEntityConfirmation = true;
        },
        getFormsAccess(){
            this.userFormAccess = {};
            let repEntityIdFk = null
            /* if (this.forGenEntityLevel.length > 0) {
                repEntityIdFk = this.forGenEntityLevel[0];
            }*/
            let repEntitiesData = []
            let repUnitsData = []
            if (this.forGenEntityLevel.length > 0) {
                repEntitiesData = this.forGenEntityLevel.map(id => {
                    return this.getHandlesData('E', id)
                })
            }
            if (this.forGenUnitLevel.length > 0) {
                repUnitsData = this.forGenUnitLevel.map(id => {
                    return this.getHandlesData('U', id)
                })
            }
            FormAccessApi.getPerUser({
                userId : this.profile.userId,
                repGroupIdFk : this.profile.repGroupIdFk,
                reportingYear : this.selectedReportingYear,
                repEntityIdFk,
                repUnitData: repUnitsData,
                repEntityData: repEntitiesData,
                repGroupIds: this.profileHandles.repGroupIds
            })
            .then(response=>{

                if (response.data) {
                    if (!response.data.error) {
                        // this.userFormAccess = response.data;
                        var formAccess = response.data;
                        if (formAccess.reportingEntityLevel.length > 0 ||
                            formAccess.reportingUnitLevel.length > 0) {

                            // Filter forms for selected year
                            let entAccForYr = [], unitAccForYr = [];
                            if (formAccess.reportingEntityLevel.length > 0) {
                                entAccForYr = formAccess.reportingEntityLevel.filter(acc=>{
                                    return acc.reportingYear==this.selectedReportingYear;
                                });
                            }

                            if (formAccess.reportingUnitLevel.length > 0) {
                                unitAccForYr = formAccess.reportingUnitLevel.filter(acc=>{
                                    return acc.reportingYear==this.selectedReportingYear;
                                });
                            }

                            if (entAccForYr.length > 0 || unitAccForYr.length > 0) {
                                this.userFormAccess.reportingEntityLevel = entAccForYr;
                                this.userFormAccess.reportingUnitLevel = unitAccForYr;
                                this.createValidationCard();
                            }
                            else {
                                this.closeLoading()
                                this.$dialog.alert({
                                    title: 'Warning',
                                    message: `Ooops! Looks like there are NO FORMS mapped to your access for selected year
                                        `+this.selectedReportingYear+`. <br><br>If this is NOT expected, please contact the Secretariat.`,
                                    type: 'is-warning'
                                });
                                return false;
                            }
                            
                        }
                        else {
                            this.closeLoading()
                            this.$dialog.alert({
                                title: 'Warning',
                                message: `Ooops! Looks like there are NO FORMS mapped to your access for selected year
                                    `+this.selectedReportingYear+`. If this is NOT expected, please contact the Secretariat.`,
                                type: 'is-warning'
                            });
                            return false;
                        }
                    }
                    else {
                        this.closeLoading()
                        this.promptServerError({response},'FormAccess.getUserAccess');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'FormAccess.getUserAccess');
            });
        },
        getHandlesData (level, id) {
            if (level === 'E') {
                let res = this.profileHandlesData.repEntities.filter(en => {
                    return en.repEntityIdFk == id
                })
                if (res.length > 0) {
                    return res[0]
                }
            } else if (level === 'U') {
                let res = this.profileHandlesData.repUnits.filter(un => {
                    return un.repUnitIdFk == id
                })
                if (res.length > 0) {
                    return res[0]
                }
            }
            return null
        },
        createValidationCard(){
            let repEntityIdFk = null;

            // GET selected entity/units ONLY
            let repEntitiesData = []
            let repUnitsData = []
            if (this.forGenEntityLevel.length > 0) {
                repEntitiesData = this.forGenEntityLevel.map(id => {
                    return this.getHandlesData('E', id)
                })
            }
            if (this.forGenUnitLevel.length > 0) {
                repUnitsData = this.forGenUnitLevel.map(id => {
                    return this.getHandlesData('U', id)
                })
            }

            let generateParams = {
                repGroupIdFk : this.profile.repGroupIdFk,
                repEntityIdFk,
                repEntityData: repEntitiesData,
                repUnitData: repUnitsData,
                userRepEntityIdFk : this.profile.repEntityIdFk,
                generatedBy : this.profile.userId,
                reportingYear : this.selectedReportingYear
            };

            ValidationCardApi.add(generateParams)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let returnData = response.data;
                        var newEntVcards = []
                        var newUntVcards = []
                        newEntVcards = returnData.entityLevelValidationCards.filter(ec => {
                            return (ec.validationCardStatus === 'No Data Entry' && ArrayUtil.getIndex(this.forGenEntityLevel,null,ec.repEntityIdFk)!== null)
                        })
                        newUntVcards = returnData.unitLevelValidationCards.filter(uc => {
                            return (uc.validationCardStatus === 'No Data Entry' && ArrayUtil.getIndex(this.forGenUnitLevel,null,uc.repUnitIdFk)!== null)
                        })                        
                        this.generateVcardFormEntries({'entity': newEntVcards,
                                                       'unit': newUntVcards });
                    }
                    else {
                        this.closeLoading()
                        this.promptServerError({response},'ValidationCard.add');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'ValidationCard.add'); 
            });
        },
        generateVcardFormEntries(vcards){
            let vfeArr = [];
            let vcardIdFk = null;
            // Prepare entity-level fields for creation
            if (vcards.entity && vcards.entity.length > 0) {
                this.userFormAccess.reportingEntityLevel.forEach(repAccess=>{
                    let vcardIdx = ArrayUtil.getIndex(vcards.entity,'repEntityIdFk',repAccess.repEntityIdFk);
                    if (vcardIdx!=null) {
                        vfeArr.push({
                            validationCardIdFk : vcards.entity[vcardIdx].validationCardId,
                            accessIdFk : repAccess.accessId,
                            reportingYear : vcards.entity[vcardIdx].reportingYear,
                            generatedBy : this.profile.userId
                        });
                        vcardIdFk = vcards.entity[vcardIdx].validationCardId;
                    }
                });
            }
            // Prepare unit-level fields for creation
            if (vcards.unit && vcards.unit.length > 0) {
                this.userFormAccess.reportingUnitLevel.forEach(repAccess=>{
                    let vcardIdx = ArrayUtil.getIndex(vcards.unit,'repUnitIdFk',repAccess.repUnitIdFk);
                    if (vcardIdx!=null) {
                        vfeArr.push({
                            validationCardIdFk : vcards.unit[vcardIdx].validationCardId,
                            accessIdFk : repAccess.accessId,
                            reportingYear : vcards.unit[vcardIdx].reportingYear,
                            generatedBy : this.profile.userId
                        });
                    }
                });
            }
            
            VfeApi.add(vfeArr)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error &&
                        response.data.isAdded) {
                        this.closeLoading()
                        this.showEntityConfirmation = false;
                        this.forGenEntityLevel = [];
                        this.forGenUnitLevel = [];
                        this.$notification.open({
                            duration: 5000,
                            message: 'Validation card created.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        if (this.showGenerateRemaining===true) {
                            this.closeGenerateModal()
                        }
                        if (vcardIdFk!=null) {
                            // Log validation card creation
                            this.logCardMovement({
                                validationCardIdFk : vcardIdFk,
                                vfeIdFk : null,
                                activityByUser : this.profile.userId,
                                activitySection : VCARD_SECTION_LOG,
                                activityMessageLog : "Validation card generated."
                            });
                        }
                        this.getActiveValidationCards();
                    }
                    else {
                        this.closeLoading()
                        this.promptServerError({response},'Vfe.add');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'Vfe.add');
            });
        },
        selectReportingYear(){
            this.getValidationPeriod();
            this.getActiveValidationCards();
        },
        cancelEntityUnitConfirmation(){
            this.showEntityConfirmation = false;
            this.forGenEntityLevel = [];
            this.forGenUnitLevel = [];
        },
        selectAll(){
            this.forGenEntityLevel = [];
            this.forGenUnitLevel = [];
            this.allMarked = !this.allMarked
            if (this.allMarked) {
                if (this.hasActiveCards) {
                    if (this.ungeneratedEntity.length > 0) {
                        this.forGenEntityLevel = this.ungeneratedEntity.map(en => {
                            return en.repEntityIdFk
                        })
                    }
                    if (this.ungeneratedUnit.length > 0) {
                        this.forGenUnitLevel = this.ungeneratedUnit.map(u => {
                            return u.repUnitIdFk
                        })
                    }
                } else {
                    this.forGenEntityLevel = this.profileHandles.repEntityIds 
                    this.forGenUnitLevel = this.profileHandles.repUnitIds
                }
                // this.forGenEntityLevel.push(this.profile.repEntityIdFk);
                // this.profile.reportingUnits.forEach(unit=>{
                //     this.forGenUnitLevel.push(unit.repUnitIdFk)
                // });
            }
        },
        prepSwimLanes(cards){
            this.swimLanes = [];
            if (ValidationCardStatus.length > 0) {
                ValidationCardStatus.forEach(status=>{
                    if (status!='Pending Validation Card') {
                        this.swimLanes.push({
                            id : this.swimLanes.length,
                            status,
                            name : status,
                            items : []
                        });
                    }
                });
                this.updateKanbanBoard(cards);
            }
            else {
                this.isLoading = false;
            }
        },
        updateKanbanBoard(cards){
            
            this.swimLanes.forEach(lane=>{
                cards.entityLevelValidationCards.forEach(ecard=>{
                    if (ecard.validationCardStatus==lane.name) {
                        lane.items.push(ecard);
                    }
                });
                cards.unitLevelValidationCards.forEach(ucard=>{
                    if (ucard.validationCardStatus==lane.name) {
                        lane.items.push(ucard);
                    }
                });
            });

            this.activeValidationCards = cards;
            this.isLoading = false;
        },
        onDrop(event){
            
            let draggedFromLane = null;
            let droppedToLane = null;

            let draggedItemDetails = null;
            let draggedCard = null;

            /* Get dragged-from lane */
            if (event.owner!=null) {
                let dragEvtElclass = event.owner.className;
                if (dragEvtElclass.match(/--/gi)) {
                    let classNames = dragEvtElclass.split('--');
                    let statusIdx = parseInt(classNames[classNames.length-1],10);

                    if (!(isNaN(statusIdx))) {
                        draggedFromLane = statusIdx;
                    }
                }
                
                /* Get dragged card */ 
                if (event.items) {

                    let itemId = "";
                    try {
                        itemId = event.items[0].id;
                    }
                    catch(dragItemErr){
                        console.log(dragItemErr);
                    }

                    if (itemId!='') {
                        let idArr = itemId.split('_');
                        let idObj = {};
                        if (idArr.length==3) {
                            idArr.forEach(str=>{
                                let prop = str.split('--');
                                idObj[prop[0]] = parseInt(prop[1],10);
                            });
                        }
                        draggedItemDetails = idObj;
                        draggedCard = this.swimLanes[idObj['lane']].items[idObj['cardIdx']];
                    }
                }
            }

            /* Get dropped-to lane */
            if (event.droptarget!=null) {

                let dropEvtElclass = event.droptarget.className;
                if (dropEvtElclass.match(/--/gi)) {
                    let classNames = dropEvtElclass.split('--');
                    let statusIdx = parseInt(classNames[classNames.length-1],10);

                    if (!(isNaN(statusIdx))) {
                        droppedToLane = statusIdx;
                    }
                }

            }

            /* Drop on the SAME lane */
            if (draggedFromLane==droppedToLane) {
                return false;
            }

            /* When card is moved forward */ 
            if (draggedFromLane < droppedToLane) {

                let laneDiff = droppedToLane - draggedFromLane;

                if (laneDiff > 1) {
                    let msg = "";
                    switch(draggedFromLane) {
                        case 0: 
                            msg = "Card from 'No Data Entry' should only be moved to 'Data Entry - In Progress'";
                            break;
                        case 1:
                            msg = "Card from 'Data Entry - In Progress' should only be moved to 'Ready for Validation'";
                            break;
                        case 2:
                            msg = "Card from 'Ready for Validation' should only be moved to 'Validated and Submitted'";
                            break;
                    }
                    // WARNING/ERROR: Not allowed to skip a lane
                    this.$dialog.alert({
                        title: 'Warning: Move not allowed',
                        message: msg,
                        type: 'is-warning'
                    });
                    return false;
                }
                // Update Kanban Swim Lanes
                if (draggedCard!=null) {

                    if (draggedFromLane > 0 && draggedCard.completionPercentage!=100) {
                        // WARNING/ERROR: Not allowed to move if not forms are not completely filled out
                        this.$dialog.alert({
                            title: 'Error: Move not allowed',
                            message: 'Card is not yet completed. Please check the forms.',
                            type: 'is-danger'
                        });
                        return false;
                    }


                    // WARNING/ERROR: Check role if ALLOWED to drag card to Validated and Submitted
                    if (droppedToLane > 2) { /* Change this to 1 if it's needed to check role for 'Ready for Validation' */
                        if (this.profile.role!=AUTHORIZED_ROLE) {
                            this.$dialog.alert({
                                title: 'Error: Not Allowed',
                                message: "Your account is restricted to move the card to <strong>"+ValidationCardStatus[droppedToLane+1]+"</strong>.",
                                type: 'is-danger'
                            });
                            return false
                        }
                    }

                    if (droppedToLane==3) {
                        // If moving to Submitted and Validated
                        if ( draggedCard.completionPercentage==100 ) {
                            this.attest(
                                draggedFromLane,
                                droppedToLane,
                                draggedItemDetails,
                                draggedCard
                            );
                            return false
                        }
                    }
                    else {
                        // Update validation card in db;
                        // status and updated by details
                        this.updateCard(
                            draggedFromLane,
                            droppedToLane,
                            draggedItemDetails,
                            draggedCard
                        );
                    }
                    
                }
                
            }
            else { 
                /* When card is moved backwards */
                this.$dialog.alert({
                    title: 'Error: Move not allowed',
                    message: `Moving the card to a previous status is not allowed. <br /><br /> <p> However, if you accidentally moved the card to its current status and you need to revert, you may contact and inform the administrator at ${supportEmail}. Please provide the reason for reverting the status. </p>`,
                    type: 'is-error'
                });
                return false;
            }
        },
        onDragStart(event){
            console.log('start drag')
        },
        onDragEnd(event){
            console.log('end drag')
        },
        updateCard(draggedFr,droppedTo,draggedItemInfo,draggedCard){
            let oldStatus = ValidationCardStatus[draggedFr+1];
            let newStatus = ValidationCardStatus[droppedTo+1];

            let param = {
                validationCardId : draggedCard.validationCardId,
                updatedBy : this.profile.userId,
                validationCardStatus : newStatus
            };

            ValidationCardApi.update({
                validationCardId : draggedCard.validationCardId,
                updatedBy : this.profile.userId,
                validationCardStatus : newStatus
            })
            .then(response=>{
                if (!response.data.error && 
                    response.data.isUpdated) {
                    // To refresh the kanban swim lanes
                    this.getActiveValidationCards();
                    // Log card movement
                    this.logCardMovement({
                        validationCardIdFk : draggedCard.validationCardId,
                        vfeIdFk : null,
                        activityByUser : this.profile.userId,
                        activitySection : VCARD_SECTION_LOG,
                        activityMessageLog : "Moved validation card from "+oldStatus+" to "+newStatus+"."
                    });
                }
                else {
                    this.promptServerError({response},'ValidationCard.update')
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ValidationCard.update')
            });
        },
        onGroupsChange(e) {
            // console.log({ e });
        },
        attest(draggedFr,droppedTo,draggedItemInfo,vcard) {
            let workspaceName = vcard.reportingEntity;
            if (vcard.reportingUnit!=null) {
                workspaceName = vcard.reportingUnit;
            }
            this.$dialog.confirm({
                title: 'Attestation',
                message: `<p>I hereby attest that:</p><ul>
                    <li style="list-style-type:disc;margin-left:1.75em;"> all the data and information in this validation card (`+workspaceName+`) have been made in good faith, duly verified by me, and, to the best of my knowledge and belief, are true and correct;</li>
                    <li style="list-style-type:disc;margin-left:1.75em;"> all the data and information in this validation card (`+workspaceName+`) are being submitted in compliance with the requirements of the PH-EITI; and</li>
                    <li style="list-style-type:disc;margin-left:1.75em;"> I have been authorized by the Board of Directors to submit the data and information to PH-EITI.</li>
                </ul><br/>
                <p>I understand that failure to submit the reportorial requirements of PH-EITI may subject the corporation to penalty under DENR Administrative Order No. 2017-07.</p>`,
                cancelText: 'Cancel',
                confirmText: 'Affirm and Proceed',
                type: 'is-success',
                onConfirm: () => this.logAttestationDetails(draggedFr,droppedTo,draggedItemInfo,vcard)
            });
        },
        logAttestationDetails(draggedFr,droppedTo,draggedItemInfo,vcard){
            ValidationCardApi.addAttestation({
                validationCardIdFk: vcard.validationCardId,
                confirmedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        // Log attestation activity
                        this.logCardMovement({
                            validationCardIdFk : vcard.validationCardId,
                            vfeIdFk : null,
                            activityByUser : this.profile.userId,
                            activitySection : VCARD_SECTION_LOG,
                            activityMessageLog : "Signed attestation."
                        });
                        this.updateCard(draggedFr,droppedTo,draggedItemInfo,vcard)
                    }
                    else {
                        this.promptServerError({response},'VcardAttestation.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'VcardAttestation.add');
            });
        },
        logCardMovement(logData) {
            ActivityLogsApi.add(logData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error &&
                        response.data.logId) {
                        /** Success */
                    }
                    else {
                        this.promptServerError({response},'ActivityLogs.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ActivityLogs.add');
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        refreshData(){
            // this.getReportingYearLov(); 
            this.getValidationPeriod();
        },
        openGenerationModal(){
            this.showGenerateRemaining = true
        },
        closeGenerateModal () {
            this.showGenerateRemaining = false
        },
        generateRemaining () {
            if (this.forGenUnitLevel.length == 0 && this.forGenEntityLevel.length == 0) {
                this.errorData = {};
                this.errorData.title = "No reporting entity/unit selected";
                this.errorData.message = "Please select from the items listed below to generate a validation card."
                return false
            }
            this.getFormsAccess()
            this.showLoading()
        },
        closeError(){
            this.errorData = null;
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        }
    },
    watch : {
        isAllSelected: function(newVal,oldVal) {
            if (newVal === true) {
                this.allMarked = true
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Dashboard</p>

        <!-- Reporting Year Selection -->
        <div class="base-box--sidepadded margin-left margin-btm--med">
            <div class="field is-grouped">
                <div class="control">
                    <b-dropdown
                        v-model="selectedReportingYear">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedReportingYear">
                                <strong>Reporting Year ({{selectedReportingYear}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Reporting Year</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(year,yearIdx) in reportingYearLov"
                            v-bind:key="yearIdx"
                            v-bind:value="year"
                            v-on:click="selectReportingYear(year)">
                            <h4>{{year}}</h4>
                        </b-dropdown-item>
                        
                    </b-dropdown>
                </div>
                <div class="control">
                    <button type="button"
                        class="button is-light tooltip is-tooltip-top"
                        data-tooltip="Refresh data"
                        v-on:click="refreshData">
                        <span class="icon">
                            <i class="fas fa-redo"></i>
                        </span>
                    </button>
                </div>
                <!-- <div class="control"
                    v-if="readableDeadline!=''"
                    style="padding:0.1rem;">
                    <b-tag 
                        type="is-warning" 
                        size="is-medium">
                        &nbsp;
                        <b-icon 
                            size="is-small"
                            pack="fa"
                            icon="clock"
                            type="is-dark"></b-icon>
                        <span>{{readableDeadline}}</span>
                    </b-tag>
                </div> -->
                <div class="control"
                    style="padding-top:0.1rem;">
                    <Timer 
                        v-if="hasActiveCards && readableDeadline && validationPeriod && validationPeriod.vPeriodStatus=='Open'"
                        :dueDate="dueDateEpoch"/>
                </div>
                <div class="control"
                    v-if="hasUngeneratedVcard">
                    <button type="button"
                        class="button is-outlined is-info"
                        data-tooltip="Generate Remaining Validation Card"
                        @click="openGenerationModal">
                        Generate Validation Card 
                    </button>
                </div>
            </div>
        </div>

        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="false" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading dashboard</span>
            </b-loading>
        </section>

        <section class="section no-padd--top app-view app-view--user"
            v-if="!isLoading"> 
            <!-- Empty State -->
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" 
                v-if="activeValidationCards.entityLevelValidationCards.length==0 &&
                        activeValidationCards.unitLevelValidationCards.length==0" >

                <!-- Company/Agency can start creating validation card; Ready for Input -->
                <div class="has-text-centered"
                    v-if="showEntityConfirmation==false && validationPeriod && validationPeriod.vPeriodStatus=='Open'">

                    <p class="title is-5">Looks like there's no validation card generated yet for {{selectedReportingYear}}.</p>
                    <p class="subtitle">To get started, click "Start".</p>
                    
                    <b-field grouped
                        position="is-centered">

                        <!-- Selected Reporting Year is the validation period/year selected
                        <b-dropdown
                            v-model="selectedReportingYear"
                            v-on:change="selectReportingYear"
                            disabled>
                            <button class="button is-primary is-outlined"
                                type="button"
                                slot="trigger">
                                <template
                                    v-if="selectedReportingYear">
                                    <strong>Reporting Year ({{selectedReportingYear}})</strong>
                                </template>
                                <template
                                    v-else>
                                    <strong>Select Reporting Year</strong>
                                </template>
                                <b-icon icon="menu-down"></b-icon>
                            </button>

                            <b-dropdown-item
                                v-for="(year,yearIdx) in reportingYearLov"
                                v-bind:key="yearIdx"
                                v-bind:value="year">
                                <h4>{{year}}</h4>
                            </b-dropdown-item>

                        </b-dropdown> -->

                        <p class="control">
                            <button class="button is-success is-large"
                                type="button"
                                v-on:click="getStarted">
                                <span class="has-text-weight-bold">START</span>
                            </button>
                        </p>
                        
                    </b-field>
                </div>

                <!-- Company/Agency cannot created validation card yet; Forms are not yet finalized -->
                <div class="has-text-centered"
                    v-if="showEntityConfirmation==false && validationPeriod && validationPeriod.vPeriodStatus=='Ready'">
                    <p class="title is-5">Forms are still being finalized for reporting year ({{selectedReportingYear}}).</p>
                    <p class="subtitle">
                        Please try this page again at a later time 
                        <span
                            v-if="profile && profile.email">
                            or check your email ({{profile.email}}) for notification<!--
                        --></span><span>.</span>
                    </p>
                </div>

                <!-- Validation Period has not started -->
                <div class="has-text-centered"
                    v-if="showEntityConfirmation==false && !validationPeriod">
                    <p class="title is-5">{{selectedReportingYear}} reporting period is not available.</p>
                    <p class="subtitle">Please contact the Secretariat to prepare the necessary forms for this period.</p>
                    <!-- or click <a href="javascript:mailto:">here</a> -->
                </div>

                <div class="columns is-mobile is-centered"
                    v-if="showEntityConfirmation">
                    <div class="column is-half">
                        <b-message title="Confirm Reporting Entity/Units" 
                            type="is-warning"
                            v-on:close="cancelEntityUnitConfirmation">
                            <p class="subtitle no-margin">
                                To proceed, please select the entity and/or units that you'll be reporting for.
                            </p>
                            <div class="margin-btm">
                                <button class="button is-outlined"
                                    type="button"
                                    v-on:click="selectAll">{{ btnSelectionLabel }} ALL</button>
                            </div>
                            
                            <div class="box"
                                v-for="(ent,entIdx) in profile.reportingEntities"
                                v-bind:key="entIdx">
                                <b-checkbox
                                    v-model="forGenEntityLevel"
                                    v-bind:native-value="ent.repEntityIdFk">
                                    <span class="has-text-weight-bold">{{ent.reportingEntity}}</span>
                                </b-checkbox>
                            </div>
                            
                            <div class="box"
                                v-for="(unit,unitIdx) in profile.reportingUnits"
                                v-bind:key="unitIdx">
                                <b-checkbox
                                    v-model="forGenUnitLevel"
                                    v-bind:native-value="unit.repUnitIdFk">
                                    <span class="has-text-weight-bold">{{unit.reportingUnit}}</span>
                                </b-checkbox>
                            </div>
                            <p class="has-text-info is-italic">
                                **Note that you can later generate validation cards for entity/units that are not selected here. <br /><br />
                            </p>

                            <div class="buttons has-text-right">
                                <button 
                                    class="button"
                                    type="button"
                                    v-on:click="cancelEntityUnitConfirmation">
                                    Cancel
                                </button>
                                <button 
                                    class="button is-info"
                                    type="button"
                                    v-bind:disabled="!hasReportingSelection"
                                    v-on:click="getFormsAccess">
                                    Confirm and Proceed
                                </button>
                            </div>

                        </b-message>
                    </div>
                </div>

            </div>
            
            <!-- Closed State -->
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" 
                v-if="validationPeriod && validationPeriod.vPeriodStatus=='Closed'">
                <div class="has-text-centered">
                    <p class="title is-5">{{selectedReportingYear}} board is now closed.</p>
                    <p class="subtitle">To view your input for this year, go to 'Summary' or click <a href="#/summary">here</a>.</p>
                </div>
            </div>

            <!-- Kanban -->
            <div v-if="validationPeriod && validationPeriod.vPeriodStatus=='Open'">
                <b-message 
                    v-if="hasActiveCards"
                    type="is-info">
                    To change the status of the card, click & drag it onto the next column's 'Drop here' section.
                </b-message>
                <div class="drag-container" 
                    v-drag-and-drop:options="dndOptions">
                    <ul class="drag-list">
                        <li class="drag-column" 
                            v-for="lane in swimLanes" 
                            v-bind:key="lane.id"
                            v-bind:class="'drag-column--'+lane.id">
                            
                            <div class="drag-column-header">
                                <h2 class="title is-5">{{ lane.name }}</h2>
                            </div>

                            <vue-draggable-group
                                v-if="lane.items"
                                v-model="lane.items"
                                v-bind:groups="swimLanes"
                                v-bind:data-id="lane.id"
                                v-on:change="onGroupsChange">

                                <ul class="drag-inner-list"
                                    v-bind:class="'list-status--'+lane.id"
                                    v-bind:data-id="lane.id">

                                    <li class="drag-item" 
                                        v-for="(card,cardIdx) in lane.items" 
                                        v-bind:key="cardIdx" 
                                        v-bind:data-id="cardIdx"
                                        v-bind:id="'lane--'+lane.id+'_cardIdx--'+cardIdx+'_validationCardId--'+card.validationCardId">

                                        <div class="columns">
                                            <div class="column">
                                                <p class="heading">
                                                    {{card.cardLevel}}
                                                </p>
                                                <p class="drag-item-text drag-item-name">
                                                    {{card.reportingUnit ? card.reportingUnit : card.reportingEntity}}
                                                </p>
                                            </div>
                                            <div class="column has-text-right">
                                                <span class="tag"
                                                    v-bind:class="'tag--'+card.validationCardStatusClass">{{card.validationCardStatus}}</span>
                                            </div>
                                        </div>

                                        <hr />
                                        
                                        <div class="columns">
                                            <div class="column">
                                                <p class="heading">No. of Entries</p>
                                                <span class="title is-5">{{card.numFormEntries}}</span>
                                            </div>
                                            <div class="column has-text-right">
                                                <p class="heading">No. of Forms</p>
                                                <p class="tag"
                                                    v-bind:class="{
                                                        'is-success':card.completionPercentage==100,
                                                        'is-light':card.completionPercentage<100
                                                    }">{{card.completedForms}} / {{card.numForms}}</p>
                                            </div>
                                        </div>

                                        <hr v-if="card.validationCardStatus=='Data Entry - In Progress' ||
                                            card.validationCardStatus=='Ready for Validation'"/>

                                        <!-- Show Edit only if status is 'Data Entry - In Progress' or 'Ready for Validation' -->
                                        <a  v-if="card.validationCardStatus=='Data Entry - In Progress' ||
                                            card.validationCardStatus=='Ready for Validation'"
                                            class="button is-success is-fullwidth"
                                            v-bind:href="'#/workspace?validationCardId='+card.validationCardId+'&reportingYear='+selectedReportingYear">
                                            <span class="icon">
                                                <i class="fas fa-pen"></i>
                                            </span>
                                            <span>Edit</span>
                                        </a>

                                        <!-- Show 'Summary' option when status is Validated and Submitted -->
                                        <a  v-if="card.validationCardStatus=='Validated and Submitted' ||
                                                card.validationCardStatus=='Ready for Validation'"
                                            class="button is-info is-fullwidth"
                                            v-bind:href="'#/summary?validationCardId='+card.validationCardId+'&reportingYear='+selectedReportingYear"
                                            style="margin-top:0.5rem">
                                            <span class="icon">
                                                <i class="fas fa-external-link-alt"></i>
                                            </span>
                                            <span>Summary</span>
                                        </a>

                                        <!-- <a  v-if="card.validationCardStatus=='Validated and Submitted'"
                                            class="button is-info is-fullwidth"
                                            v-bind:href="'#/workspace?validationCardId='+card.validationCardId"
                                            style="margin-top:0.5rem;">
                                            <span>Open</span>
                                        </a> -->

                                        
                                        
                                    </li>

                                    <li class="drag-item empty-drop-area"
                                        v-if="lane.status!='No Data Entry'"
                                        >Drop here</li>

                                    <li class="drag-item no-data-area"
                                        v-if="lane.status=='No Data Entry' && lane.items.length==0"
                                        >No data available</li>
                                </ul>

                            </vue-draggable-group>
                        </li>
                    </ul>
                </div>
            </div>
            
        </section>

        <!-- Generate Remaining -->
        <b-modal
            has-modal-card
            v-bind:active.sync="showGenerateRemaining"
            v-on:close="closeGenerateModal">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Generate Validation Card</p>
                </header>
                <section class="modal-card-body">
                    <div class="notification is-danger"
                        v-if="errorData!=null">
                        <button class="delete"
                            type="button"
                            v-on:click="closeError"></button>
                        <strong>Error: {{errorData.title}}</strong>
                        <p>{{errorData.message}}</p>
                    </div>
                    <div class="margin-btm">
                        <button class="button is-outlined"
                            type="button"
                            v-on:click="selectAll">{{ btnSelectionLabel }} ALL</button>
                    </div>
                    <div class="box"
                        v-if="ungeneratedEntity.length > 0">
                        <div class="box"
                            v-for="(ent,entIdx) in ungeneratedEntity"
                            v-bind:key="entIdx">
                            <b-checkbox
                                v-model="forGenEntityLevel"
                                v-bind:native-value="ent.repEntityIdFk">
                                <span class="has-text-weight-bold">{{ent.reportingEntity}}</span>
                            </b-checkbox>
                        </div>
                    </div>
                    <div v-if="ungeneratedUnit.length > 0">
                        <div class="box"
                            v-for="(unit,unitIdx) in ungeneratedUnit"
                            v-bind:key="unitIdx">
                            <b-checkbox
                                v-model="forGenUnitLevel"
                                v-bind:native-value="unit.repUnitIdFk">
                                <span class="has-text-weight-bold">{{unit.reportingUnit}}</span>
                            </b-checkbox>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="closeGenerateModal">
                        <span>Cancel</span>
                    </a>
                    
                    <!-- v-bind:disabled="newFormGroupPreset.groupPresetName.trim().length < 3" -->
                    <a class="button is-success"
                        v-on:click="generateRemaining">
                        <span>Generate Validation Card</span>
                    </a>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<style scoped>
.drag-list {
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: border-box;
    margin-right: 1em;
    padding-right: 0.45em;
}
.drag-column {
    display: block;
    min-width: 24%;
    margin-right: 0.35em;
    border-top: 5px solid #333;
    background-color: whitesmoke;
    padding-right: 0.65em;
    padding-left: 0.65em;
    padding-bottom: 1em;
}
.drag-column--0 { border-color: rgb(187, 187, 187); }
.drag-column--1 { border-color: #f1be31; }
.drag-column--2 { border-color: #6e20ec; }
.drag-column--3 { border-color: #54d03e; }

.drag-column-header {
    text-align: left;
    box-sizing: border-box;
    padding: 1em 0.45em 1em 0.45em;
    border-radius: 4px;
}

.drag-inner-list {
    display: flex;
    flex-direction: column;
}
.drag-item {
    padding: 1.25em 0.85em 1.25em 0.85em;
    margin-top:0.25em;
    transition: ease-out;
    outline: none;
    margin: 0.2em auto;
    width: 97%;
    background-color: white;
    border-radius: 3px;
    border:1px solid rgb(207, 206, 206);
    box-shadow: -1px 1px 4px rgb(201, 201, 201);
    transition: ease-in; 
}
.drag-item-name {
    font-weight: 600;
    font-size: 1.1em;
}
.drag-item > hr {
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
}
/* items grabbed state */
[aria-grabbed="true"] {
    /* background: #3db4f8; */
    color: rebeccapurple;
}
.empty-drop-area {
    height: 135px;
    border: 1px dashed #ccc;
    color: rgb(184, 184, 184);
    text-align: center;
    vertical-align: middle;
    line-height: 5.5em;
    background-color: #f5f5f5;
    box-shadow: none;
}
.no-data-area {
    height: 135px;
    color: rgb(184, 184, 184);
    text-align: center;
    vertical-align: middle;
    line-height: 5.5em;
    background-color: #f5f5f5;
    box-shadow: none;
}
@keyframes nodeInserted {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 0.8;
  }
}
.item-dropzone-area {
    height: 6rem;
    background: #888;
    opacity: 0.8;
    animation-duration: 0.5s;
    animation-name: nodeInserted;
    margin-left: 0.6rem;
    margin-right: 0.6rem;
}
</style>




// WEBPACK FOOTER //
// src/views/dashboard/DashboardView.vue